import { APP_CONFIG } from "../config/app.config";

const STYLES = `
@keyframes maint-in  { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
@keyframes maint-spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }
`;

export default function MaintenancePage() {
  return (
    <div className="login-screen">
      <style>{STYLES}</style>
      <div className="login-card" style={{ animation:"maint-in 0.45s cubic-bezier(.22,.68,0,1.2) both" }}>
        <div className="band"/>
        <div style={{ padding:"36px 40px 40px", textAlign:"center" }}>
          <img src="/logo.png" alt="logo"
            style={{ height:48, objectFit:"contain", margin:"0 auto 14px", display:"block" }}/>
          <div style={{ fontSize:32, margin:"8px 0 16px", display:"inline-block", animation:"maint-spin 6s linear infinite" }}>🔧</div>
          <h1 style={{
            fontFamily:"var(--ff-title)", fontSize:18, fontWeight:900,
            color:"#fff", margin:"0 0 12px", letterSpacing:0.3,
          }}>
            Maintenance en cours
          </h1>
          <p style={{ fontSize:13, color:"var(--text-muted)", lineHeight:1.7, margin:"0 0 28px" }}>
            L'application est temporairement indisponible.<br/>
            Veuillez réessayer dans quelques instants.
          </p>
          <p style={{ fontSize:11, color:"var(--text-faint)", margin:0 }}>
            {APP_CONFIG.copyright}
          </p>
        </div>
      </div>
    </div>
  );
}
